export const renderCollaborationCursors = (user: Record<string, any>): HTMLElement => {
  const color = user.color || '#7D7D7D';
  const cursor = document.createElement('span');
  cursor.classList.add('ProseMirror-yjs-cursor');
  cursor.style.borderColor = color;
  cursor.style.borderLeft = `1px solid ${color}`;
  cursor.style.borderRight = `1px solid ${color}`;
  const userSpan = document.createElement('span');
  userSpan.classList.add('ProseMirror-yjs-cursor-user');
  /**
   * The default behaviour is to create the cursor with
   * the name tag (flag) visible.
   * Unless explicitly set as 'down', display it.
   */
  if (user?.flag !== 'down') {
    userSpan.classList.add('ProseMirror-yjs-cursor-up');
  }
  userSpan.style.backgroundColor = color;
  userSpan.style.color = 'whitesmoke';
  userSpan.setAttribute('spellcheck', 'false');
  userSpan.contentEditable = 'false';
  userSpan.id = `yjs-cursor-${user.yjsId}`;
  userSpan.style.whiteSpace = 'nowrap';
  userSpan.setAttribute('data-username', user.name);
  cursor.insertBefore(userSpan, null);
  return cursor;
};
